import React, { useState, useEffect, useRef } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { colors } from "@mui/material";
import successImg from "../../assets/images/userprofile/successImg.png";
import { axiosInstance_agent } from "../../axiosInstance-agent";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import logo_nathi_profile from "../../assets/images/userprofile/logo_nathi_profile_logo_1.png";
import Preloader from "../../Components/Preloader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper", //box color
  border: "1px solid white", //box border
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};

const cityList = [
  "Hyderabad",
  "Visakhapatnam",
  "Vijayawada",
  "Guntur",
  "Nellore",
  "Kurnool",
  "Kakinada",
  "Rajamahendravaram",
  "Kadapa",
  "Mangalagiri-Tadepalli",
  "Tirupati",
  "Anantapuram",
  "Ongole",
  "Vizianagaram",
  "Eluru",
  "Proddatur",
  "Nandyal",
  "Adoni",
  "Madanapalle",
  "Machilipatnam",
  "Tenali",
  "Chittoor",
  "Hindupur",
  "Srikakulam",
  "Bhimavaram",
  "Tadepalligudem",
  "Guntakal",
  "Dharmavaram",
  "Gudivada",
  "Narasaraopet",
  "Kadiri",
  "Tadipatri",
  "Chilakaluripet",
  "Palakollu",
];

const services = [
  "Wedding Photography",
  "Pre-Wedding Photoshoot",
  "Birthday Photography",
  "Couple Portraits",
  "Drone Photography",
  "Photo Albums & Prints",
  "Event Photography",
  "Maternity Photoshoot",
  "Cinematic Videography",
  "Event Planning & Coordination",
  "Vendor & Venue Management",
  "Stage & Decor Setup",
  "Bridal Makeup & Hair Styling",
  "Skincare & Facial Treatments",
  "Party & Occasion Makeup",
  "Brand Endorsements & Promotions",
  "Content Creation & Reels Production",
  "Audience Engagement & Campaigns",
];

const SUPPORTED_FORMATS = ["image/jpeg", "image/png", "application/pdf"];

const validationSchema = Yup.object({
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
    .required("Mobile number is required"),
  min_price: Yup.number().required("Min Price is required"),
  max_price: Yup.number().required("Max Price is required"),
  about: Yup.string().required("About is required"),
  service_provided: Yup.array().min(
    1,
    "Please select at least Services Provided"
  ),
  locations: Yup.array().min(1, "Please select at least one city"),
});

export function EventBasicProfile({ userId }) {
  const [loader, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdownServices, setShowDropdownServices] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [documentPreview, setDocumentPreview] = useState(null);
  const [userImagePreviews, setUserImagePreviews] = useState([]); // for displaying both server + new images
  const [newUserImages, setNewUserImages] = useState([]); // only new files to be submitted

  const dropdownRef = useRef(null);
  const dropdownServicesRef = useRef(null);

  console.log(userId);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownServicesRef.current &&
        !dropdownServicesRef.current.contains(event.target)
      ) {
        setShowDropdownServices(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCityChange = (city) => {
    const selected = formik.values.locations;
    if (selected.includes(city)) {
      formik.setFieldValue(
        "locations",
        selected.filter((c) => c !== city)
      );
    } else {
      formik.setFieldValue("locations", [...selected, city]);
    }
  };

  const handleServiceProvidedChange = (service) => {
    const selected = formik.values.service_provided;
    if (selected.includes(service)) {
      formik.setFieldValue(
        "service_provided",
        selected.filter((c) => c !== service)
      );
    } else {
      formik.setFieldValue("service_provided", [...selected, service]);
    }
  };

  const fetchData = async () => {
    try {
      // const response = await axiosInstance_agent.get(`/beautician/${userId}`);
      const response = await axiosInstance_agent.get(`/eventhallmanager/${userId}`);
      const data = response?.data?.data;

      formik.setValues({
        first_name: data?.user?.first_name || "",
        last_name: data?.user?.last_name || "",
        email: data?.user?.email || "",
        mobile: data?.user?.mobile || "",
        agency_name: data?.user?.agency_name || "",
        profile_pic: data?.user?.profile_pic || "",
        document: data?.user?.document || "",
        category: "Event Hall Manager",
        min_price: data.min_price || "",
        max_price: data.max_price || "",
        about: data.about || "",
        service_provided: data.service_provided || "",
        locations: data.locations || "",
        user_image: [],
        name: "Event Hall Manager",
      });

      setImagePreview(data.user.profile_pic || null);
      setDocumentPreview(data.user.document || null);
      setUserImagePreviews(
        (data.user_image || []).map((imgObj) => imgObj.image_url)
      );
      setNewUserImages([]); // reset new files
    } catch (err) {
      toast.error("Failed to load profile data");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      mobile: "",
      agency_name: "",
      profile_pic: null,
      document: null,
      category: "Event Hall Manager",
      min_price: "",
      max_price: "",
      about: "",
      service_provided: [],
      locations: [],
      user_image: [],
      name: "Event Hall Manager",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const formData = new FormData();

        // Append arrays as JSON strings
        formData.append("locations", JSON.stringify(values.locations));
        formData.append(
          "service_provided",
          JSON.stringify(values.service_provided)
        );

        // Append other values
        for (const key in values) {
          if (
            key !== "profile_pic" &&
            key !== "document" &&
            key !== "user_image" &&
            key !== "locations" &&
            key !== "service_provided"
          ) {
            formData.append(key, values[key]);
          }
        }

        // Append profile picture
        if (Array.isArray(imagePreview) && imagePreview.length > 0) {
          imagePreview.forEach((file) => {
            formData.append("profile_pic", file);
          });
        } else if (values.profile_pic) {
          formData.append("profile_pic", values.profile_pic);
        }

        // Append document
        if (values.document) {
          formData.append("document", values.document);
        }

        // Append user images
        if (Array.isArray(values.user_image) && values.user_image.length > 0) {
          values.user_image.forEach((file) => {
            formData.append("user_image", file);
          });
        }

        const response = await axiosInstance_agent.put(
          // `/beautician/${userId}`,
           `/eventhallmanager/${userId}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        console.log("✅ Submitted:", response.data);
        toast.success("Form data successfully submitted");
        handleOpen();
        setTimeout(() => handleClose(), 2000);
        fetchData();
      } catch (error) {
        console.error("❌ Error:", error);
        toast.error("Submission failed. Please try again.");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
   <>
      {loader && <Preloader/>}
    <div className="MatchMainContainer">
      <form onSubmit={formik.handleSubmit}>
        <div>
          {/* row1 */}
          <div className="MatchSubcontainer">
            <div>
              <div className="match-lableName">First Name</div>
              <div className="matchTextbox">
                <input
                  type="text"
                  name="first_name"
                  placeholder="Enter First Name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.first_name}
                />
                {formik.touched.first_name && formik.errors.first_name && (
                  <div className="error">{formik.errors.first_name}</div>
                )}
              </div>
            </div>

            <div>
              <div className="match-lableName">Last Name</div>
              <div className="matchTextbox">
                <input
                  type="text"
                  name="last_name"
                  placeholder="Enter Last Name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.last_name}
                />
                {formik.touched.last_name && formik.errors.last_name && (
                  <div className="error">{formik.errors.last_name}</div>
                )}
              </div>
            </div>
          </div>

          {/* row2 */}
          <div className="MatchSubcontainer">
            <div>
              <div className="match-lableName">Profile Image</div>
              <div className="matchTextbox">
                <label
                  htmlFor="profile_pic_input"
                  className="custom-file-label"
                >
                  {formik.values.profile_pic?.name || "Browse"}
                </label>
                <input
                  type="file"
                  id="profile_pic_input"
                  className="custom-file-input"
                  accept="image/*"
                  name="profile_pic"
                  onChange={(event) => {
                    formik.setFieldValue(
                      "profile_pic",
                      event.currentTarget.files[0]
                    );
                  }}
                />
                {imagePreview && (
                  <img
                    src={imagePreview}
                    alt="Profile Preview"
                    style={{ width: "100px", marginTop: "10px" }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = logo_nathi_profile; // fallback image
                    }}
                  />
                )}
              </div>
            </div>

            <div>
              <div className="match-lableName">Email</div>
              <div className="matchTextbox">
                <input
                  type="email"
                  name="email"
                  placeholder="Enter Email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="error">{formik.errors.email}</div>
                )}
              </div>
            </div>
          </div>
          {/* row3 */}
          <div className="MatchSubcontainer">
            <div>
              <div className="match-lableName">Mobile Number</div>
              <div className="matchTextbox">
                <input
                  type="number"
                  name="mobile"
                  onChange={formik.handleChange}
                  value={formik.values.mobile}
                  maxLength={10}
                  disabled
                />
                {formik.touched.mobile && formik.errors.mobile && (
                  <div className="error">{formik.errors.mobile}</div>
                )}
              </div>
            </div>

            <div>
              <div className="match-lableName">Agency Name</div>
              <div className="matchTextbox">
                <input
                  type="text"
                  name="agency_name"
                  onChange={formik.handleChange}
                  value={formik.values.agency_name}
                />
              </div>
            </div>
          </div>
          {/* row4 */}
          <div className="MatchSubcontainer">
            <div>
              <div className="match-lableName">Min Price</div>
              <div className="matchTextbox">
                <input
                  type="number"
                  name="min_price"
                  onChange={formik.handleChange}
                  value={formik.values.min_price}
                  min="0" // doesn't allow nagative values
                />
                {formik.touched.min_price && formik.errors.min_price && (
                  <div className="error">{formik.errors.min_price}</div>
                )}
              </div>
            </div>
            <div>
              <div className="match-lableName">Max Price</div>
              <div className="matchTextbox">
                <input
                  type="number"
                  name="max_price"
                  onChange={formik.handleChange}
                  value={formik.values.max_price}
                  min="0"
                />
                {formik.touched.max_price && formik.errors.max_price && (
                  <div className="error">{formik.errors.max_price}</div>
                )}
              </div>
            </div>
          </div>
          {/* row5 */}
          <div className="MatchSubcontainer">
            <div>
              <div className="city-dropdown-wrapper" ref={dropdownServicesRef}>
                <label className="match-lableName">Select Services</label>
                <div
                  className="city-dropdown-btn"
                  onClick={() => setShowDropdownServices((prev) => !prev)}
                >
                  {formik.values.service_provided.length > 0
                    ? formik.values.service_provided.join(", ")
                    : "Select services"}
                </div>

                {showDropdownServices && (
                  <div className="city-dropdown-list">
                    {services.map((services) => (
                      <label key={services} className="city-dropdown-item">
                        <input
                          type="checkbox"
                          value={services}
                          checked={formik.values.service_provided.includes(
                            services
                          )}
                          onChange={() => handleServiceProvidedChange(services)}
                        />
                        {services}
                      </label>
                    ))}
                  </div>
                )}

                {formik.touched.locations && formik.errors.locations && (
                  <div className="city-error">{formik.errors.locations}</div>
                )}
              </div>
            </div>
          </div>
          {/* row6 */}
          <div className="MatchSubcontainer">
            <div>
              <div className="match-lableName">Event Images</div>
              <div className="matchTextbox">
                <label htmlFor="user_image" className="custom-file-label">
                  {newUserImages.length
                    ? newUserImages.map((file) => file.name).join(", ")
                    : "Browse"}
                </label>
                <input
                  type="file"
                  id="user_image"
                  className="custom-file-input"
                  accept="image/*"
                  name="user_image"
                  multiple
                  onChange={(event) => {
                    const files = Array.from(event.currentTarget.files);
                    setNewUserImages(files); // store only new files
                    formik.setFieldValue("user_image", files);

                    const previews = files.map((file) =>
                      URL.createObjectURL(file)
                    );
                    setUserImagePreviews((prev) => [
                      ...prev.filter((p) => p.startsWith("http")),
                      ...previews,
                    ]);
                  }}
                />
                <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                  {userImagePreviews.map((src, index) => (
                    <img
                      key={index}
                      src={src}
                      alt={`event-${index}`}
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        marginTop: "10px",
                      }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = logo_nathi_profile; // fallback image
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>

            <div>
              <div className="city-dropdown-wrapper" ref={dropdownRef}>
                <label className="match-lableName">Select Cities</label>
                <div
                  className="city-dropdown-btn"
                  onClick={() => setShowDropdown((prev) => !prev)}
                >
                  {formik.values.locations.length > 0
                    ? formik.values.locations.join(", ")
                    : "Select Cities"}
                </div>

                {showDropdown && (
                  <div className="city-dropdown-list">
                    {cityList.map((city) => (
                      <label key={city} className="city-dropdown-item">
                        <input
                          type="checkbox"
                          value={city}
                          checked={formik.values.locations.includes(city)}
                          onChange={() => handleCityChange(city)}
                        />
                        {city}
                      </label>
                    ))}
                  </div>
                )}

                {formik.touched.locations && formik.errors.locations && (
                  <div className="city-error">{formik.errors.locations}</div>
                )}
              </div>
            </div>
          </div>

          {/* row7 */}
          <div className="MatchSubcontainer">
            <div>
              <div className="match-lableName">Aadharcard or Pancard</div>
              <div className="matchTextbox">
                <label htmlFor="document_input" className="custom-file-label">
                  {formik.values.document?.name || "Browse"}
                </label>
                <input
                  type="file"
                  id="document_input"
                  className="custom-file-input"
                  accept="image/*"
                  name="document"
                  onChange={(event) => {
                    formik.setFieldValue(
                      "document",
                      event.currentTarget.files[0]
                    );
                  }}
                />
                {documentPreview && (
                  <img
                    src={documentPreview}
                    alt="Document Preview"
                    style={{ width: "100px", marginTop: "10px" }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = logo_nathi_profile; // fallback image
                    }}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="MatchSubcontainer">
            <div>
              <div className="match-lableName">About</div>
              <div className="matchTextbox">
                <textarea
                  name="about"
                  placeholder="Type Here"
                  rows={4}
                  onChange={formik.handleChange}
                  value={formik.values.about}
                ></textarea>
                {formik.touched.about && formik.errors.about && (
                  <div className="error">{formik.errors.about}</div>
                )}
              </div>
            </div>
          </div>

          <div className="btnMakerAddSave m-2 mb-2">
            <Button type="submit" disabled={loader}>
              {loader ? "Saving..." : "Save"}
            </Button>
          </div>
        </div>
      </form>

      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose} //close modal on background click
          closeAfterTransition
        >
          <Fade in={open}>
            <Box sx={style} className="modal-box">
              <img srcSet={successImg} />
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h2"
              >
                Thank You
              </Typography>
              <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                The profile has been successfully updated
              </Typography>
            </Box>
          </Fade>
        </Modal>
      </div>
    </div>
   </>
  );
}
